import React, {useEffect, useState} from 'react';
import post from '../utils/post.js';
import usePopupAnimation from '../utils/usePopupAnimation.js';

function getSessionNoteLines(note) {
	const noteText = String(note || '').trim();

	if (noteText === '') {
		return ['Zařízení není uložené.'];
	}

	return noteText.split(';').map((line) => line.trim()).filter((line) => line !== '');
}

function getSessionDetailRows(session) {
	const rows = [{label: 'IP', value: session.IP || '-'}];
	const noteRows = getSessionNoteLines(session.NOTE).map((line) => {
		const separatorIndex = line.indexOf(':');

		if (separatorIndex === -1) {
			return {label: line, value: ''};
		}

		return {
			label: line.slice(0, separatorIndex).trim(),
			value: line.slice(separatorIndex + 1).trim() || '-',
		};
	});

	return rows.concat(noteRows);
}

export default function UserSessionsPopup({showSessions, closeSessions, user}) {
	const popupAnimationMs = 300;
	const [data, setData] = useState([]);
	const [loading, setLoading] = useState(false);
	const [deletingToken, setDeletingToken] = useState('');
	const {shouldRender, isClosing} = usePopupAnimation(showSessions, popupAnimationMs);

	useEffect(() => {
		if (showSessions && user?.ID) {
			getData();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [showSessions, user?.ID]);

	const getData = () => {
		if (!user?.ID) {
			return;
		}

		setLoading(true);

		post('getListUserSessions', {USRID: user.ID, notRefreshSession: true})
			.then((res) => {
				setData(res.data?.data || []);
				setLoading(false);
			})
			.catch((error) => {
				console.error(error);
				setLoading(false);
			});
	};

	const deleteSession = (sessionToken) => {
		if (!user?.ID || sessionToken === '') {
			return;
		}

		setDeletingToken(sessionToken);

		post('deleteUserSession', {USRID: user.ID, TOKEN: sessionToken, notRefreshSession: true})
			.then(() => {
				setData((prevRows) => prevRows.filter((session) => session.TOKEN !== sessionToken));
				setDeletingToken('');
			})
			.catch((error) => {
				console.error(error);
				setDeletingToken('');
			});
	};

	const list = data.map((session) => {
		const detailRows = getSessionDetailRows(session);

		return (
			<div className={`user-sessions-popup__item${parseInt(session.IS_CURRENT, 10) === 1 ? ' is-current' : ''}`} key={session.TOKEN}>
				<div className="user-sessions-popup__main">
					<div className="user-sessions-popup__top">
						<span className="user-sessions-popup__date">{session.DT_CHANGE}</span>
						{parseInt(session.IS_CURRENT, 10) === 1 ? <span className="user-sessions-popup__badge">aktuální</span> : null}
					</div>
					<div className="user-sessions-popup__token" title={session.TOKEN}>
						{session.TOKEN}
					</div>
					<div className="user-sessions-popup__details">
						{detailRows.map((row) => (
							<div className="user-sessions-popup__detail-row" key={`${row.label}:${row.value}`}>
								<span className="user-sessions-popup__detail-label">{row.label}:</span>
								<span className="user-sessions-popup__detail-value">{row.value}</span>
							</div>
						))}
					</div>
				</div>
				<button type="button" className="user-sessions-popup__delete" onClick={() => deleteSession(session.TOKEN)} disabled={deletingToken === session.TOKEN} title="Smazat session" aria-label="Smazat session">
					X
				</button>
			</div>
		);
	});

	return (
		<>
			{shouldRender ? (
				<div className={`popup user-sessions-popup${isClosing ? ' popup--closing' : ''}`}>
					<div className={`popup_content user-sessions-popup__content${isClosing ? ' popup_content--closing' : ''}`}>
						<div className="popup_content_in_head">
							<div className="popup_content_in_head_in">Sessions</div>
							<img
								alt=""
								className="popup_content_in_head_in-close"
								onClick={() => {
									closeSessions();
								}}
							/>
						</div>
						<div className="popup_content_in_body popup_content_in_body--hidden-scrollbar user-sessions-popup__body">
							<div className="popup_content_in_body_in user-sessions-popup__body-in">
								<div className="popup_content_in_body--hidden-scrollbar user-sessions-popup__list-wrap">
									<div className="user-sessions-popup__list">
										{list.length > 0 ? list : <div className="user-sessions-popup__empty">{loading ? 'Načítám sessions...' : 'Žádné sessions nebyly nalezeny.'}</div>}
									</div>
								</div>
							</div>
						</div>
						<div className="popup_content_in_foot">
							<div className="popup_content_in_foot_in user-sessions-popup__foot">
								<button
									type="button"
									className="button"
									onClick={() => {
										closeSessions();
									}}
								>
									Zpět
								</button>
							</div>
						</div>
					</div>
				</div>
			) : (
				''
			)}
		</>
	);
}
